import React, { useState, useContext } from 'react';
import {
  Button,
  CircularProgress,
  Modal,
  TextareaAutosize,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core';
import { ScheduleWeekPageContext } from 'page/Schedule/WeekSchedule/index';
import { useAgendaValidation } from 'hook/agenda/validation';
import moment from 'moment'; // Importando moment

export function ModalAcceptValidation({
  open,
  close,
  title,
  setStatusError = () => {},
  setResponseMessage = () => {},
  setTitleMessage = () => {},
  setOpenAlertMessage = () => {},
}) {
  const { loading, putAgendaValidation } = useAgendaValidation();

  const {
    agendaDetails,
    selectedUnit,
    setAgendaDetailsData = () => {},
    handleGetAgenda = () => {},
  } = useContext(ScheduleWeekPageContext);

  const [validated_description, setValidatedDescription] = useState('');
  const [startTime, setStartTime] = useState(''); // Formato: "YYYY-MM-DDTHH:mm"
  const [endTime, setEndTime] = useState(''); // Formato: "YYYY-MM-DDTHH:mm"
  const [showTimeFields, setShowTimeFields] = useState(false);
  const [intervalStart, setIntervalStart] = useState('');
  const [intervalEnd, setIntervalEnd] = useState('');
  const [showIntervalFields, setShowIntervalFields] = useState(false);
  const [error, setError] = useState({
    description: false,
    startTime: false,
    endTime: false,
    intervalStart: false,
    intervalEnd: false,
  });

  const handleSubmit = () => {
    const newError = {
      description: validated_description === '',
      startTime: showTimeFields && startTime === '',
      endTime: showTimeFields && endTime === '',
      intervalStart: showIntervalFields && intervalStart === '',
      intervalEnd: showIntervalFields && intervalEnd === '',
    };

    if (
      newError.description ||
      newError.startTime ||
      newError.endTime ||
      newError.intervalStart ||
      newError.intervalEnd
    ) {
      setError(newError);
      return;
    }

    // Validação: data de fim deve ser posterior à data de início
    if (showTimeFields && new Date(endTime) <= new Date(startTime)) {
      setError({ ...error, endTime: true });
      setResponseMessage(
        'A data de saída deve ser posterior à data de entrada!'
      );
      setStatusError(true);
      return;
    }

    if (
      showIntervalFields &&
      new Date(intervalEnd) <= new Date(intervalStart)
    ) {
      setError({ ...error, intervalEnd: true });
      setResponseMessage(
        'A data de fim do intervalo deve ser posterior à data de início!'
      );
      setStatusError(true);
      return;
    }

    setError({
      description: false,
      startTime: false,
      endTime: false,
      intervalStart: false,
      intervalEnd: false,
    });

    const formData = {
      id: agendaDetails?.id,
      validated_status: 2,
      validated_description,
      ...(showTimeFields && {
        user_date_start: moment(startTime).format('YYYY-MM-DD HH:mm:ss'), // Formata para "2024-03-31 20:40:00"
      }),
      ...(showTimeFields && {
        user_date_end: moment(endTime).format('YYYY-MM-DD HH:mm:ss'), // Formata para "2024-03-31 20:40:00"
      }),
      ...(showIntervalFields && {
        interval_date_start: moment(intervalStart).format(
          'YYYY-MM-DD HH:mm:ss'
        ),
        interval_date_end: moment(intervalEnd).format('YYYY-MM-DD HH:mm:ss'),
      }),
      unit: { id: selectedUnit?.id },
      scale: { id: agendaDetails?.scale.id },
    };

    putAgendaValidation({ agenda_id: agendaDetails?.id }, formData)
      .then((data) => {
        close();
        setValidatedDescription('');
        setStartTime('');
        setEndTime('');
        setShowTimeFields(false);
        setIntervalStart('');
        setIntervalEnd('');
        setShowIntervalFields(false);
        setAgendaDetailsData(data);
        setTitleMessage('Plantão validado com sucesso!');
        setResponseMessage('');
        setOpenAlertMessage(true);
        setTimeout(() => {
          handleGetAgenda();
        }, 300);
      })
      .catch(() => {
        setTimeout(() => {
          setTitleMessage('Falha ao validar plantão!');
          setResponseMessage('');
          setStatusError(true);
        }, 300);
      });
  };

  return (
    <Modal
      open={open}
      onClose={close}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          width: '360px',
          maxHeight: '90vh',
          overflowY: 'auto',
          padding: '2rem',
          background: '#FFFFFF',
          borderRadius: '10px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <p>{title}</p>
        <TextareaAutosize
          style={{
            width: '100%',
            height: showTimeFields ? '80px' : '128px',
            borderRadius: '4px',
            marginTop: '16px',
            border: '1px solid #A2A5A8',
            padding: '1rem',
          }}
          onChange={(e) => setValidatedDescription(e.target.value)}
          rowsMax={showTimeFields ? 4 : 8}
          placeholder="Observação"
        />
        {error.description && (
          <span style={{ fontSize: 12, marginTop: 5, color: 'red' }}>
            Obrigatório!
          </span>
        )}
        <FormControlLabel
          control={
            <Checkbox
              checked={showTimeFields}
              onChange={(e) => {
                const checked = e.target.checked;
                setShowTimeFields(checked);
                if (checked) {
                  if (agendaDetails?.date_start) {
                    setStartTime(
                      moment(agendaDetails.date_start).format(
                        'YYYY-MM-DDTHH:mm'
                      )
                    );
                  }
                  if (agendaDetails?.date_end) {
                    setEndTime(
                      moment(agendaDetails.date_end).format('YYYY-MM-DDTHH:mm')
                    );
                  }
                }
              }}
              color="primary"
            />
          }
          label="Informar horário do profissional"
          style={{ marginTop: '16px' }}
        />
        {showTimeFields && (
          <>
            <div style={{ marginTop: '16px' }}>
              <label style={{ fontSize: '14px' }}>
                Data e Horário de Entrada
              </label>
              <input
                type="datetime-local"
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
                style={{
                  width: '100%',
                  height: '40px',
                  borderRadius: '4px',
                  border: '1px solid #A2A5A8',
                  padding: '0.5rem',
                  marginTop: '8px',
                }}
              />
              {error.startTime && (
                <span style={{ fontSize: 12, color: 'red' }}>Obrigatório!</span>
              )}
            </div>
            <div style={{ marginTop: '16px' }}>
              <label style={{ fontSize: '14px' }}>
                Data e Horário de Saída
              </label>
              <input
                type="datetime-local"
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
                style={{
                  width: '100%',
                  height: '40px',
                  borderRadius: '4px',
                  border: '1px solid #A2A5A8',
                  padding: '0.5rem',
                  marginTop: '8px',
                }}
              />
              {error.endTime && (
                <span style={{ fontSize: 12, color: 'red' }}>
                  Obrigatório e deve ser posterior à entrada!
                </span>
              )}
            </div>
          </>
        )}
        <FormControlLabel
          control={
            <Checkbox
              checked={showIntervalFields}
              onChange={(e) => {
                const checked = e.target.checked;
                setShowIntervalFields(checked);
                if (
                  checked &&
                  agendaDetails?.date_start &&
                  agendaDetails?.date_end
                ) {
                  const start = moment(agendaDetails.date_start);
                  const end = moment(agendaDetails.date_end);
                  const durationMin = end.diff(start, 'minutes');
                  const middle = start.clone().add(durationMin / 2, 'minutes');
                  setIntervalStart(middle.format('YYYY-MM-DDTHH:mm'));
                  setIntervalEnd(
                    middle.clone().add(1, 'hour').format('YYYY-MM-DDTHH:mm')
                  );
                }
              }}
              color="primary"
            />
          }
          label="Informar horário de intervalo"
          style={{ marginTop: '8px' }}
        />
        {showIntervalFields && (
          <>
            <div style={{ marginTop: '16px' }}>
              <label style={{ fontSize: '14px' }}>
                Data e Horário de Início do Intervalo
              </label>
              <input
                type="datetime-local"
                value={intervalStart}
                onChange={(e) => setIntervalStart(e.target.value)}
                style={{
                  width: '100%',
                  height: '40px',
                  borderRadius: '4px',
                  border: '1px solid #A2A5A8',
                  padding: '0.5rem',
                  marginTop: '8px',
                }}
              />
              {error.intervalStart && (
                <span style={{ fontSize: 12, color: 'red' }}>Obrigatório!</span>
              )}
            </div>
            <div style={{ marginTop: '16px' }}>
              <label style={{ fontSize: '14px' }}>
                Data e Horário de Fim do Intervalo
              </label>
              <input
                type="datetime-local"
                value={intervalEnd}
                onChange={(e) => setIntervalEnd(e.target.value)}
                style={{
                  width: '100%',
                  height: '40px',
                  borderRadius: '4px',
                  border: '1px solid #A2A5A8',
                  padding: '0.5rem',
                  marginTop: '8px',
                }}
              />
              {error.intervalEnd && (
                <span style={{ fontSize: 12, color: 'red' }}>
                  Obrigatório e deve ser posterior ao início!
                </span>
              )}
            </div>
          </>
        )}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            style={{
              background: '#0F83AD',
              width: '136px',
              height: '32px',
              fontSize: '12px',
              borderRadius: '4px',
              color: '#ffffff',
              textTransform: 'unset',
              marginTop: '32px',
            }}
            onClick={handleSubmit}
          >
            {loading ? (
              <CircularProgress size={20} style={{ color: 'white' }} />
            ) : (
              'Confirmar'
            )}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
